export var EValidationRule;
(function (EValidationRule) {
  EValidationRule["gt"] = "gt";
  EValidationRule["gte"] = "gte";
  EValidationRule["lt"] = "lt";
  EValidationRule["lte"] = "lte";
  EValidationRule["gtField"] = "gtField";
  EValidationRule["gteField"] = "gteField";
  EValidationRule["ltField"] = "ltField";
  EValidationRule["lteField"] = "lteField";
  EValidationRule["required"] = "required";
  EValidationRule["conditionalRequired"] = "conditionalRequired";
  EValidationRule["eq"] = "eq";
  EValidationRule["eqField"] = "eqField";
  EValidationRule["pattern"] = "pattern";
})(EValidationRule || (EValidationRule = {}));